// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3-x_H","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__lmkDK"};